// extracted by mini-css-extract-plugin
export default {"inputs":"send-external-fill-modal_inputs__sq15h","button":"send-external-fill-modal_button__gwWHk","modalButton":"send-external-fill-modal_modalButton__cEkuK"};